<template>
    <div class="cgs-register-page">
        <van-nav-bar :border="false">
            <template #left>
                <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
            </template>
        </van-nav-bar>
        <div class="cgs-register-title">
            <img :src="require('@/assets/image/iconLogo.png')" width="100px">
        </div>
        <div class="cgs-app-main-content">
            <div class="cgs-register-step step-one">
                <div class="register-input-container">
                    <van-field v-model="tel" type="digit" placeholder="请输入手机号码" :error-message="telError" @blur="setTel" />
                </div>
                <div class="register-input-container">
                    <van-field v-model="code" center clearable placeholder="请输入短信验证码" :error-message="codeError">
                        <template #button>
                            <div v-if="codeLoading">
                                <van-loading size="20px">{{ codeLoadingTime + 's' }}</van-loading>
                            </div>
                            <span @click="sendCode" v-else>发送验证码</span>
                        </template>
                    </van-field>
                </div>
                <div class="register-input-container">
                    <van-field v-model="password" placeholder="请输入密码" type="password" />
                </div>
                <div class="register-input-container">
                    <van-button type="info" style="width: 100%" :loading="retrieveLoading" @click="nextStep">确定</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Field, Button, Loading, NavBar } from 'vant';
import { checkByUsername, getValidationCode, checkValidationCode, retrieve } from "@/api/authority"
import qs from 'qs'

export default {
    components: {
        vanField: Field,
        vanButton: Button,
        vanLoading: Loading,
        vanNavBar:NavBar
    },
    data () {
        return {
            tel:'',
            code:'',
            password: '',
            telError: '',
            codeError: '',
            retrieveLoading: false,
            codeLoading: false,
            codeTimer: null,
            codeLoadingTime: 60
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        testTel() {
            let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;//正则表达式
            return reg.test(this.tel);//正则表达式的test()方法，返回值Boolen
        },
        setTel() {
            if (this.testTel()) {
                // this.telError = ''
            } else {
                this.$Notify({ type: "danger", message: '手机号码格式错误' });
            }
        },
        setCodeLoading() {
            this.codeLoading = true
            this.codeTimer = setInterval(() => {
                if (this.codeLoadingTime === 0) {
                    clearInterval(this.codeTimer)
                    this.codeTimer = null
                    this.codeLoading = false
                    this.codeLoadingTime = 60
                }
                this.codeLoadingTime--
            }, 1000)
        },
        async sendCode() {
            if (!this.testTel()) {
                this.$Notify({ type: "danger", message: '手机号码格式错误' });
                return
            }
            try {
                let checkResult = await checkByUsername(this.tel)
                if (checkResult.code === 200) {
                    if (checkResult.data.isExist) {
                        this.setCodeLoading()
                        let codeResult = await getValidationCode(this.tel)
                        if (codeResult.code === 200) {
                            this.$Notify({ type: "success", message: "验证码已发送" });
                        }
                    } else {
                        this.$Notify({ type: "danger", message: '该手机号码未注册' });
                    }
                }
            } catch (err) {
            }
        },
        async nextStep() {
            if (this.password === '' || this.tel === '' ||  this.code === '') {
                this.$Notify({ type: "danger", message: '请将信息填写完整' });
                return
            }
            try {
                this.retrieveLoading = true
                let checkResult = await checkValidationCode(this.tel, this.code)
                if (checkResult.code === 200) {
                    let params = {
                        confirmPassword: this.password,
                        newPassword: this.password,
                        phoneNumber: this.tel,
                        "validationCode": this.code
                    }
                    let retrieveResult = await retrieve(params)
                    if (retrieveResult.code === 200) {
                        this.$router.push('/login')
                        this.$Notify({ type: "success", message: "修改成功，请登录" });
                    } else {
                        this.$Notify({ type: "danger", message: retrieveResult.msg });
                    }
                } else if (checkResult.code === 300) {
                    this.$Notify({ type: "danger", message: checkResult.msg });
                }
                this.retrieveLoading = false
            } catch (err) {
                this.retrieveLoading = false
            }
        }  
    }
}
</script>

<style scoped>
.cgs-register-page {}

.cgs-register-title {
    text-align: center;
    padding: 50px;
    font-size: 18px
}

.cgs-register-page .register-message {
    color: rgba(0, 0, 0, 0.3);
    padding-left: 10px;
    font-size: 14px;

}

.cgs-register-page .hide {
    visibility: hidden;
    opacity: 0;
    transform: translateY(10px);
    transition: .5s;
}

.cgs-register-page .show {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
}
</style>

<style scoped>
.cgs-register-step {
    padding: 0px 40px;
}

.register-input-container {
    margin-bottom: 15px;
}
</style>

<style>
.cgs-register-step .van-cell {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}
</style>